import { EmptyStateImage } from '@assets/images';
import { Flex, Text } from '@chakra-ui/react';

export default function EmptyState({
    title = 'Data Tidak Tersedia',
    description = 'Saat ini, data product belum tersedia.',
    height = '25vh',
    Image = EmptyStateImage,
}) {
    return (
        <Flex height={height} alignItems="center" justifyContent="center" flexDirection="column" my={10}>
            <Image />
            <Text fontSize={'20px'} fontWeight={'bold'} mb={'8px'}>
                {title}
            </Text>
            <Text>{description}</Text>
        </Flex>
    );
}
